import axios from 'axios'

axios.defaults.baseURL = 'https://stock.danielarturomassara.com:8000'

export default axios
